import {
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Stack,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { SmsHistoryItem } from "../api/sms-history";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";

interface UnreadSmsListProps {
  unreadSms: SmsHistoryItem[];
  unreadCount: number;
  isLoading: boolean;
  onMarkAsRead: (smsId: number) => void;
  isMarkingAsRead: boolean;
  onClose: () => void;
}

export default function UnreadSmsList({
  unreadSms,
  unreadCount,
  isLoading,
  onMarkAsRead,
  isMarkingAsRead,
  onClose,
}: UnreadSmsListProps) {
  const navigate = useNavigate();

  return (
    <Card sx={{ minWidth: 400, maxWidth: 500, maxHeight: 600 }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography variant="h6" component="div">
            پیام‌های خوانده نشده
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {unreadCount} پیام
          </Typography>
        </Stack>
        <Divider sx={{ mb: 2 }} />
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 4,
            }}
          >
            <CircularProgress size={24} />
          </Box>
        ) : unreadSms.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 4,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              پیام خوانده نشده‌ای وجود ندارد
            </Typography>
          </Box>
        ) : (
          <List
            sx={{
              maxHeight: 450,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.2)",
                borderRadius: "4px",
              },
            }}
          >
            {unreadSms.map((sms, index) => (
              <div key={sms.id}>
                <ListItem
                  sx={{
                    flexDirection: "column",
                    alignItems: "flex-start",
                    py: 1.5,
                  }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    sx={{ width: "100%", mb: 1 }}
                  >
                    <ListItemText
                      primary={
                        <Stack
                          direction="row"
                          spacing={0.5}
                          alignItems="center"
                        >
                          {sms.customerName && (
                            <>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                  fontSize: "0.7rem",
                                  fontWeight: 400,
                                }}
                              >
                                {sms.customerName}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                  fontSize: "0.7rem",
                                }}
                              >
                                -
                              </Typography>
                            </>
                          )}
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            {sms.phoneNumber}
                          </Typography>
                        </Stack>
                      }
                      secondary={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            mb: 1,
                          }}
                        >
                          {sms.message}
                        </Typography>
                      }
                    />
                    <Button
                      size="small"
                      variant="outlined"
                      color="success"
                      startIcon={<CheckCircleIcon />}
                      onClick={() => onMarkAsRead(sms.id)}
                      disabled={isMarkingAsRead}
                      sx={{ ml: 1, minWidth: 120 }}
                    >
                      خواندن
                    </Button>
                  </Stack>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.7rem" }}
                  >
                    {moment
                      .from(sms.occurredOn, "en", "YYYY-MM-DDTHH:mm:ss")
                      .format("jYYYY/jMM/jDD - HH:mm")}
                  </Typography>
                </ListItem>
                {index < unreadSms.length - 1 && <Divider />}
              </div>
            ))}
          </List>
        )}
        {/* {unreadSms.length > 0 && (
          <>
            <Divider sx={{ my: 2 }} />
            <Button
              fullWidth
              variant="text"
              onClick={() => {
                onClose();
                navigate("/setting/sms-history");
              }}
            >
              مشاهده همه پیام‌ها
            </Button>
          </>
        )} */}
      </CardContent>
    </Card>
  );
}
